import React, { useEffect } from 'react';
import classNames from 'classnames';
import { humanFileSize } from '../FileChooserUtils';
import { getVersionBrowserColoringClass } from '../../versionBrowser/utils';
import AccurityButton from '../../buttons/components/AccurityButton';
var renderFileListItem = function (file) {
    var parts = [file.name];
    if (file.size && file.size > 0) {
        parts.push("" + humanFileSize(file.size));
    }
    return React.createElement("li", { key: file.name }, parts.join(' - '));
};
var renderFileList = function (files) {
    if (!files || files.length === 0) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("label", { className: "FileChooser__fileListLabel" }, files.length === 1 ? 'File' : 'Files'),
        React.createElement("ul", { className: "FileChooser__fileList" }, files.map(renderFileListItem))));
};
/**
 * File Chooser (used for Upload Field)
 */
var FileChooser = function (_a) {
    var _b = _a.label, label = _b === void 0 ? 'Choose file' : _b, _c = _a.multiple, multiple = _c === void 0 ? false : _c, onFileSelection = _a.onFileSelection, files = _a.files, accept = _a.accept, name = _a.name, className = _a.className, style = _a.style, disabled = _a.disabled, sizeRestriction = _a.sizeRestriction, coloring = _a.coloring;
    var inputRef = null;
    useEffect(function () {
        if (inputRef != null && files.length === 0) {
            inputRef.value = '';
        }
    }, [inputRef, files.length]);
    var validateFiles = function (filesList) {
        if (sizeRestriction) {
            sizeRestriction = typeof sizeRestriction === 'number' ? sizeRestriction : parseFloat(sizeRestriction);
            if (!isNaN(sizeRestriction)) {
                for (var i = 0; i < filesList.length; i++) {
                    if ((filesList[i].size) > sizeRestriction) {
                        alert("Can not upload. File size exceeds " + humanFileSize(sizeRestriction));
                        return false;
                    }
                }
            }
        }
        return true;
    };
    var onFileChange = function (e) {
        var changedFiles = e.nativeEvent.target.files;
        if (validateFiles(changedFiles)) {
            onFileSelection(Array.from(changedFiles));
        }
    };
    return (React.createElement("div", { className: classNames('FileChooser', className, getVersionBrowserColoringClass(coloring)), style: style },
        React.createElement(AccurityButton, { onClick: function () { return inputRef && !disabled ? inputRef.click() : null; }, "aria-label": "file-chooser-flat-button-" + name, variant: "outlined", disabled: disabled, fullWidth: true, className: "FileChooser__button" }, label),
        React.createElement("input", { name: name, ref: function (node) { inputRef = node; }, style: { display: 'none' }, type: "file", accept: accept, multiple: multiple, onChange: onFileChange }),
        renderFileList(files)));
};
export default FileChooser;
//# sourceMappingURL=FileChooser.js.map